import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.css']
})
export class SignatureModalComponent implements OnInit, AfterViewInit{
  @Input() id;
  @Output() saveSignature = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();
  @ViewChild('signatureCanvas', { static: false }) signatureCanvas: ElementRef<HTMLCanvasElement>;
  signaturePad: SignaturePad;
  // tslint:disable-next-line: ban-types
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 460,
    canvasHeight: 300
  };
  isSubmitted = false;
  isEmpty = false;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.signatureCanvas?.nativeElement) {
      this.signaturePad = new SignaturePad(this.signatureCanvas.nativeElement, this.signaturePadOptions as any);
      this.signaturePad.clear();
    }
  }

  save() {
    this.isSubmitted = true;
    this.isEmpty = false;
    if (this.signaturePad.isEmpty()) {
      this.isEmpty = true;
      return;
    }
    this.saveSignature.emit(this.signaturePad.toDataURL('image/png'));
  }

  clearSignature() {
    this.signaturePad.clear();
  }
}
